/* src/app/components/lead-details/participant-information/lead-detail-address-info/lead-detail-address-info.component.css */
[nz-icon] {
  margin-right: 6px;
  font-size: 1.429rem;
  color: #3c86f5;
  cursor: pointer;
}
/*# sourceMappingURL=lead-detail-address-info.component-L6KGDRIT.css.map */
